import { HTMLAttributes } from 'react';
import { Link, LinkProps } from 'react-router';

import { css, styled } from 'styled-components';

import { media } from '../themes/signup';

interface SpotlightItemProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  label?: React.ReactNode;
  textContents: React.ReactNode[];
  ctaButton?: LinkProps;
}

const Container = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.spotlightBackground};
    border-radius: 24px;
    display: grid;
    font-size: 15px;
    font-weight: 700;
    gap: 20px;
    line-height: 150%;
    padding: 24px;

    ${media.large`
      max-width: 45em;
    `}
  `,
);

const TextContent = styled.div(
  ({ theme }) => `
  color: ${theme.colors.white2};
  display: grid;
  font-weight: 400;
  gap: 10px;

  p {
    margin: 0;
  }
`,
);

export const Label = styled.h3(
  ({ theme }) => `
  background: rgb(122 117 115 / 25%);
  border-radius: 5px;
  color: ${theme.colors.white};
  font-family: ${theme.fonts};
  font-size: inherit;
  font-style: normal;
  font-weight: inherit;
  justify-self: left;
  margin: 0;
  padding: 4px 12px;
`,
);

const StyledLink = styled(Link)(
  ({ theme }) => `
  background-color: ${theme.colors.white2};
  border-radius: 5px;
  color: ${theme.colors.grayDarkest};
  padding: 4px 12px;
  text-align: center;
  text-decoration: none;

  &[disabled] {
    cursor: not-allowed;
    background-color: ${theme.colors.grayLight};
  }
`,
);

export const SpotlightItem = ({ label, ctaButton, textContents, ...props }: SpotlightItemProps) => {
  return (
    <Container {...props}>
      {label && <Label>{label}</Label>}

      <TextContent>
        {textContents.map((text, index) => (
          <p key={index} style={{ margin: '0' }}>
            {text}
          </p>
        ))}
      </TextContent>

      {ctaButton && <StyledLink {...ctaButton} />}
    </Container>
  );
};
